import { changeOrderEvaluationEvent } from "../../../../../_events/evaluation/create.event";
import { alertError } from "../../../../../_utils/alerts";

export default function SelectPosition({ form, term, total, position, activity, load = () => {} }){

    const changePosition = (order_value, uuid) => {
        changeOrderEvaluationEvent({
            order_value,
            form,
            term,
            uuid: uuid ? uuid : activity,
        })
        .then(json => {
            load();
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    return(
        <div>
            <div
                style={{ margin: '0 10px', cursor: 'grabbing' }}
                draggable
                onDragStart={(e) => {
                    e.dataTransfer.setData("activity", activity);
                }}
                onDrop={(e) => {
                    changePosition(position, e.dataTransfer.getData("activity"));
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                }}
            >
                <svg width={25} height={25} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M12.9511 8.59515L12.5875 8.23781C11.069 6.7455 10.3098 5.99934 9.48673 6C9.21786 6.00021 8.95184 6.05411 8.70481 6.15843C7.94859 6.47775 7.55155 7.45818 6.75747 9.41903L6.70001 9.56094C6.47489 10.1168 6.36233 10.3948 6.18157 10.619C6.04444 10.7891 5.87938 10.9356 5.6932 11.0523C5.44779 11.2061 5.15496 11.2878 4.5693 11.4511C3.66115 11.7045 3.20707 11.8311 3.00555 12.1012C2.8558 12.302 2.7898 12.5514 2.82108 12.7984C2.86316 13.1307 3.19693 13.4588 3.86446 14.1148L4.88148 15.1143L5.92632 16.1412L5.94409 16.1586L6.97115 17.168C7.63868 17.8241 7.97244 18.1521 8.31063 18.1934C8.56197 18.2242 8.81575 18.1593 9.02 18.0121C9.29483 17.8141 9.42371 17.3678 9.68146 16.4753C9.84768 15.8997 9.9308 15.6119 10.0873 15.3708C10.2061 15.1878 10.3551 15.0256 10.5282 14.8908C10.7563 14.7132 11.0391 14.6025 11.6048 14.3813L11.7492 14.3248C13.7444 13.5444 14.742 13.1542 15.0669 12.411C15.173 12.1682 15.2279 11.9068 15.2281 11.6425C15.2287 10.8336 14.4695 10.0875 12.9511 8.59515Z" fill="#1C274C"></path> <path opacity="0.5" d="M3.2706 18.7857L5.94386 16.1586L5.92608 16.1411L4.88125 15.1143L2.218 17.7512C1.92733 18.0369 1.92733 18.5 2.218 18.7857C2.50867 19.0714 2.97993 19.0714 3.2706 18.7857Z" fill="#1C274C"></path> <g opacity="0.5"> <path fillRule="evenodd" clipRule="evenodd" d="M22.0003 8.37699C22.0003 8.78098 21.667 9.10848 21.256 9.10848H16.294C15.8829 9.10848 15.5497 8.78098 15.5497 8.37699C15.5497 7.97301 15.8829 7.64551 16.294 7.64551H21.256C21.667 7.64551 22.0003 7.97301 22.0003 8.37699Z" fill="#1C274C"></path> <path fillRule="evenodd" clipRule="evenodd" d="M22.0003 12.7659C22.0003 13.1699 21.667 13.4974 21.256 13.4974H17.2864C16.8753 13.4974 16.5421 13.1699 16.5421 12.7659C16.5421 12.3619 16.8753 12.0344 17.2864 12.0344H21.256C21.667 12.0344 22.0003 12.3619 22.0003 12.7659Z" fill="#1C274C"></path> <path fillRule="evenodd" clipRule="evenodd" d="M22.0003 17.1548C22.0003 17.5588 21.667 17.8863 21.256 17.8863H12.3244C11.9133 17.8863 11.5801 17.5588 11.5801 17.1548C11.5801 16.7508 11.9133 16.4234 12.3244 16.4234H21.256C21.667 16.4234 22.0003 16.7508 22.0003 17.1548Z" fill="#1C274C"></path> </g> </g></svg>
            </div>
        </div>
    );

    /*
    return(
        <select
            value={position}
            onChange={(e) => {
                changePosition(e.target.value);
            }}
        >
            {
                Array.from({ length: total }).map((_, index) => (
                    <option value={index + 1} key={`option_position_${index}`} >
                        {index + 1}
                    </option>
                ))
            }
        </select>
    );
    */
}